export default "__VITE_ASSET__aee562bb__"